import React, { useContext, useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Card,

} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CreditCardIcon from "@mui/icons-material/CreditCard"; // Not used - online payment disabled

import OfferCard from "../../../componet/offer-card";
import FormModal from "../../../componet/offerModal";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import CustomButton from "../../../shared/custom-button/custom-button";
import { RootState } from "../../../redux/store/store";
import { useSelector } from "react-redux";
import {
  createTeacherOfferService,
  getAllTeacherOfferService,
  sendOfferTeacherService,
} from "../../../services/teacher-offer";
import { SnackbarContext } from "../../../config/hooks/use-toast";

const Offer = () => {
  const role = useSelector(
    (state: RootState) => state?.user?.userData?.role.name,
  );

  const snackbarContext = useContext(SnackbarContext);

  const [data, setData] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState<any>(null);
  const [selectedOffer, setSelectedOffer] = useState<any>(null);
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<'online' | 'upload'>('upload'); // Default to upload only
  const fetchData = () => {
    getAllTeacherOfferService()
      .then((res) => {
        console.log(res.data);
        setData(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const handleUpdateOffer = (updatedOffer: any) => {
    setData((prevOffers: any[]) =>
      prevOffers.map((offer) =>
        offer.id === updatedOffer.id ? updatedOffer : offer,
      ),
    );
  };
  const handleUpdateAfterDelete = () => {
    fetchData();
  };
  useEffect(() => {
    fetchData();
  }, []);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleAction = (formData: any) => {
    createTeacherOfferService(formData)
      .then((res) => {
        fetchData();
        handleCloseModal();
        if (snackbarContext) {
          snackbarContext.showMessage(
            "Succes",
            "Offre Ajouter avec succée",
            "success",
          );
        }
      })
      .catch((e) => {
        console.log(e);
      });
    console.log("Form Data:", formData);
  };

  const handleCloseProfileDialog = () => {
    setSelectedProfile(null);
  };

  const handleOfferClick = (offer: any) => {
    setSelectedOffer(offer);
    
    // For free offers, skip payment modal
    if (offer.price === 0) {
      setIsConfirmModal(true);
    } else {
      // For paid offers, show payment modal
      setIsConfirmModal(true);
      setSelectedFile(null);
      setPaymentMethod('upload'); // Reset to upload method only
    }
  };

  const handleBackToMainView = () => {
    setIsConfirmModal(false);
    setSelectedOffer(null);
    setSelectedFile(null);
    setPaymentMethod('upload');
  };

  // COMMENTED OUT: Online payment method disabled
  /* const handleOnlinePayment = async () => {
    if (snackbarContext) {
      snackbarContext.showMessage(
        "Info",
        "Redirection vers la plateforme de paiement...",
        "info",
      );
    }

    try {
      // Call backend to initiate payment and get payment URL
      if (!selectedOffer) throw new Error("Aucune offre sélectionnée");
      const payload = {
        teacher_id: teacherId,
        teacher_offer_id: selectedOffer.id,
        payment_type: 'paymee',
      };
      
      // @ts-ignore
      const { initiateTeacherPaymeePaymentService } = await import("../../../services/payment-service");
      const result = await initiateTeacherPaymeePaymentService(payload);
      if (result && result.payment_url) {
        window.location.href = result.payment_url;
      } else {
        throw new Error("URL de paiement non reçue");
      }
    } catch (e) {
      console.log(e);
      if (snackbarContext) {
        snackbarContext.showMessage(
          "Erreur",
          "Erreur lors de l'initialisation du paiement en ligne",
          "error"
        );
      }
    }
  }; */



  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    setSelectedFile(file);
  };

  const handleCardClick = () => {
    const inputElement = document.getElementById("file-input");
    if (inputElement) {
      inputElement.click();
    }
  };
  const handleConfirmPayment = () => {
    // For free offers, send directly without payment
    if (selectedOffer.price === 0) {
      const formData = new FormData();
      sendOfferTeacherService(selectedOffer.id, formData)
        .then((res) => {
          console.log(res);
          handleBackToMainView();
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Succès",
              "Vous avez rejoint l'offre gratuite avec succès",
              "success",
            );
          }
        })
        .catch((e) => {
          console.log(e);
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Erreur",
              "Erreur lors de la souscription à l'offre gratuite",
              "error"
            );
          }
        });
      return;
    }

    // For paid offers, only upload payment method is available
    // Online payment method has been disabled
    // if (paymentMethod === 'online') {
    //   handleOnlinePayment();
    // } else {
      // Handle upload payment
      if (!selectedFile) {
        if (snackbarContext) {
          snackbarContext.showMessage(
            "Erreur",
            "Veuillez téléverser un reçu de paiement",
            "error"
          );
        }
        return;
      }

      const confirmedData = new FormData();
      confirmedData.append("paymentImage", selectedFile);
      confirmedData.append("paymentMethod", paymentMethod);
      
      sendOfferTeacherService(selectedOffer.id, confirmedData)
        .then((res) => {
          console.log(res);
          handleBackToMainView();
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Succès",
              "Votre paiement a été envoyé avec succès",
              "success",
            );
          }
        })
        .catch((e) => {
          console.log(e);
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Erreur",
              "Une erreur est survenue lors de l'envoi du paiement",
              "error"
            );
          }
        });
    // }  // Closing the commented online payment condition
  };
  return (
    <div className="min-h-screen bg-[#F8FAFB] relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] -mr-64 -mt-64 pointer-events-none"></div>
      
      <div className={`w-full px-4 md:px-10 py-10 max-w-[1600px] mx-auto relative z-10`}>
        {isConfirmModal ? (
          selectedOffer && selectedOffer.price === 0 ? (
            // Free offer modal
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-title/20 backdrop-blur-sm">
              <div className="w-full max-w-md bg-white rounded-[3rem] shadow-2xl overflow-hidden p-10 flex flex-col items-center">
                <div className="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center text-primary mb-8 shadow-inner">
                   <CheckCircleIcon style={{ fontSize: 40 }} />
                </div>
                <h2 className="text-2xl font-black text-title uppercase tracking-tight text-center mb-2">
                  {selectedOffer.title}
                </h2>
                <p className="text-[10px] font-bold text-primary uppercase tracking-[0.4em] mb-6">Offre gratuite</p>
                
                <p className="text-text/60 font-medium text-center mb-10 leading-relaxed px-4">
                  Vous allez rejoindre cette offre gratuitement. Voulez-vous confirmer votre inscription ?
                </p>
                
                <div className="flex flex-col w-full gap-4">
                  <button
                    onClick={handleConfirmPayment}
                    className="w-full py-5 bg-primary text-white font-black text-[11px] uppercase tracking-[0.3em] rounded-2xl shadow-xl shadow-primary/20 hover:scale-[1.02] transition-all"
                  >
                    Confirmer l'adhésion
                  </button>
                  <button
                    onClick={handleBackToMainView}
                    className="w-full py-4 text-text/30 font-black text-[10px] uppercase tracking-[0.3em] hover:text-red-500 transition-all"
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          ) : (
            // Paid offer modal
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-title/20 backdrop-blur-sm">
              <div className="w-full max-w-md bg-white rounded-[3rem] shadow-2xl overflow-hidden p-10 flex flex-col items-center">
                <div className="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center text-primary mb-8 shadow-inner">
                   <CheckCircleIcon style={{ fontSize: 40 }} />
                </div>
                <h2 className="text-2xl font-black text-title uppercase tracking-tight text-center mb-2">
                   Confirmer l'Offre
                </h2>
                <p className="text-[10px] font-bold text-primary uppercase tracking-[0.4em] mb-6">Paiement Requis</p>
              
              {/* Payment Method Selection - COMMENTED OUT: Only upload method available now 
              <div className="w-full mb-6">
                <Typography className="mb-3 text-center font-montserrat_medium">
                  Choisissez votre méthode de paiement:
                </Typography>
                <ToggleButtonGroup
                  value={paymentMethod}
                  exclusive
                  onChange={(event, newMethod) => {
                    if (newMethod !== null) {
                      setPaymentMethod(newMethod);
                    }
                  }}
                  className="w-full"
                >
                  <ToggleButton 
                    value="upload" 
                    className="flex-1 py-3"
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: '#1976d2',
                        color: 'white',
                        '&:hover': {
                          backgroundColor: '#1565c0',
                        },
                      },
                    }}
                  >
                    <CloudUploadIcon className="mr-2" />
                    Téléverser un reçu
                  </ToggleButton>
                </ToggleButtonGroup>
              </div>
              */}

              {/* Online payment method disabled - only upload available */}
                <p className="text-text/60 font-medium text-center mb-8 leading-relaxed px-4">
                  Veuillez fournir une image claire du reçu de paiement pour activer votre forfait.
                </p>
                <div 
                  onClick={handleCardClick}
                  className="w-full h-40 border-2 border-dashed border-gray-100 rounded-[2rem] bg-gray-50 flex flex-col items-center justify-center gap-2 cursor-pointer group hover:border-primary/40 hover:bg-white transition-all mb-8 overflow-hidden relative"
                >
                  <input type="file" id="file-input" accept="image/*" className="hidden" onChange={handleFileChange} />
                  {selectedFile ? (
                    <div className="flex flex-col items-center">
                       <CheckCircleIcon className="text-primary mb-2" />
                       <span className="text-[10px] font-black text-title uppercase tracking-widest break-all px-6 text-center">{selectedFile.name}</span>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center text-text/30 group-hover:text-primary transition-all">
                       <AddIcon fontSize="large" />
                       <span className="text-[10px] font-black uppercase tracking-widest">Ajouter le reçu</span>
                    </div>
                  )}
                </div>
              
                <div className="flex flex-col w-full gap-4">
                  <button
                    onClick={handleConfirmPayment}
                    className="w-full py-5 bg-[#05322B] text-white font-black text-[11px] uppercase tracking-[0.3em] rounded-2xl shadow-xl shadow-black/20 hover:bg-primary transition-all duration-500"
                  >
                    Envoyer le reçu
                  </button>
                  <button
                    onClick={handleBackToMainView}
                    className="w-full py-4 text-text/30 font-black text-[10px] uppercase tracking-[0.3em] hover:text-red-500 transition-all"
                  >
                    Annuler
                  </button>
                </div>
            </div>
          </div>
        )
      ) : (
        <div className="space-y-12">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 pb-8 border-b border-gray-100">
               <div>
                  <h1 className="text-4xl font-black text-title uppercase tracking-tighter">Offres Professeurs</h1>
                  <p className="text-[11px] font-bold text-primary uppercase tracking-[0.4em] mt-2">Partagez votre expertise avec notre communauté</p>
               </div>
            </div>

            {data && data.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
                {data.map((offer: any, index: number) => (
                  <div key={index} className="flex justify-center">
                    <OfferCard
                      offer={offer}
                      onclick={() => handleOfferClick(offer)}
                      onUpdateOffer={handleUpdateOffer}
                      onDeleteOffer={handleUpdateAfterDelete}
                      onSubscribed={fetchData}
                    />
                  </div>
                ))}

                {role === "ROLE_ADMIN" && (
                  <div className="flex justify-center">
                    <button
                      onClick={handleOpenModal}
                      className="w-full max-w-[380px] h-[600px] flex flex-col items-center justify-center gap-6 bg-gray-50/50 border-4 border-dashed border-gray-100 rounded-[3rem] transition-all duration-500 hover:border-primary/40 hover:bg-white hover:shadow-2xl hover:-translate-y-3 group overflow-hidden relative"
                    >
                      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
                      <div className="relative z-10 flex flex-col items-center">
                         <div className="w-24 h-24 bg-white rounded-[2.5rem] shadow-sm flex items-center justify-center text-text/20 group-hover:text-primary group-hover:scale-110 transition-all duration-700 border border-gray-50">
                            <AddIcon style={{ fontSize: 40 }} />
                         </div>
                         <h3 className="mt-8 text-xl font-black text-title uppercase tracking-tight">Ajouter Offre</h3>
                         <p className="mt-2 text-[10px] font-bold text-text/30 uppercase tracking-[0.2em]">Nouveau forfait professeur</p>
                      </div>
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center min-h-[40vh] text-center border-2 border-dashed border-gray-100 rounded-[3rem] p-20 bg-gray-50/30">
                <div className="w-20 h-20 bg-gray-100 rounded-3xl flex items-center justify-center text-text/20 text-4xl mb-8">
                  <span>🎓</span>
                </div>
                <h3 className="text-xl font-black text-title uppercase tracking-tight mb-2">Aucune offre disponible</h3>
                <p className="text-text/40 font-medium mb-10 max-w-sm">Revenez bientôt pour découvrir les forfaits enseignants.</p>
                {role === "ROLE_ADMIN" && (
                  <button onClick={handleOpenModal} className="px-10 py-5 bg-primary text-white font-black text-[11px] uppercase tracking-[0.3em] rounded-2xl shadow-xl shadow-primary/20 hover:-translate-y-1 transition-all">
                    Créer la première offre
                  </button>
                )}
              </div>
            )}
          </div>
        )}

        <FormModal
          open={isModalOpen}
          onClose={handleCloseModal}
          modalTitle="Gestion des Offres"
          buttonText={selectedOffer ? "Mettre à jour" : "Publier l'Offre"}
          onButtonClick={handleAction}
        />

        {/* Profile Dialog Modernized */}
        <Dialog
          open={Boolean(selectedProfile)}
          onClose={handleCloseProfileDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            className: "rounded-[3rem] p-10 shadow-2xl border border-gray-50 overflow-y-auto no-scrollbar"
          }}
        >
           <div className="flex flex-col items-center relative">
              <button onClick={handleCloseProfileDialog} className="absolute -top-4 -right-4 w-10 h-10 flex items-center justify-center rounded-2xl bg-gray-50 text-text/30 hover:text-red-500 transition-all">
                <span className="text-2xl font-light">&times;</span>
              </button>
              
              <div className="relative mb-8">
                 <div className="w-32 h-32 bg-primary/10 rounded-[2.5rem] flex items-center justify-center overflow-hidden shadow-inner">
                    {selectedProfile?.photo ? (
                      <img src={selectedProfile.photo} alt="Profile" className="w-full h-full object-cover" />
                    ) : (
                      <PersonIcon style={{ fontSize: 64 }} className="text-primary" />
                    )}
                 </div>
              </div>
              
              <h2 className="text-3xl font-black text-title uppercase tracking-tight mb-1">{selectedProfile?.name}</h2>
              <p className="text-[10px] font-bold text-primary uppercase tracking-[0.4em] mb-10">Détails de l'enseignant</p>
              
              <div className="w-full space-y-4">
                 <div className="flex items-center gap-6 p-6 bg-gray-50 rounded-3xl border border-gray-100/50 group hover:bg-white hover:border-primary/20 transition-all">
                    <div className="w-12 h-12 bg-white rounded-2xl shadow-sm flex items-center justify-center text-primary group-hover:scale-110 transition-all">
                       <PhoneIcon fontSize="small" />
                    </div>
                    <div className="flex flex-col">
                       <span className="text-[9px] font-black text-text/30 uppercase tracking-widest mb-1">Téléphone</span>
                       <span className="font-bold text-title">{selectedProfile?.phone}</span>
                    </div>
                 </div>
              </div>
              
              <button 
                 onClick={handleCloseProfileDialog}
                 className="mt-10 w-full py-5 bg-title text-white font-black text-[11px] uppercase tracking-[0.3em] rounded-2xl shadow-xl shadow-title/20 hover:bg-primary transition-all duration-500"
              >
                 Fermer le profil
              </button>
           </div>
        </Dialog>
      </div>
    </div>
  );
};

export default Offer;
